import sha1 from "js-sha1";
import _ from "lodash";
import { BaseEvent } from "./events";

const LOCATION_1 = "app";

const LOCATION_2 = {
    LEARN: "learn",
    LIGHT_LISTING: "lightListing",
    LIVE_AUCTION: "liveAuction",
    REGISTRATION: "registration",
    LOGIN: "login",
    HEADER: "header",
    POST_REG_SURVEY: "postRegistrationSurvey",
    PROMO_BANNER: "promoBanner",
};

//mandatory function before any push to data layer
//// must use ////
export function cleanEventObject(object) {
    Object.keys(object).forEach((key) =>
        [null, undefined].includes(object[key]) ? delete object[key] : {}
    );
    return object;
}
export default class GA {
    static _pushDataLayer(object) {
        if (window["dataLayer"] === undefined || !dataLayer) {
            return;
        }
        dataLayer.push(cleanEventObject(object));
    }

    static setItemDetails({ valueCategory }) {
        BaseEvent.setToDataObject({
            valueCategory: _.camelCase(valueCategory),
        });
    }
    static registartionFormClicked() {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.REGISTRATION],
            actionedObject: "continue",
        });
    }
    static registartionFormViewed() {
        BaseEvent.open({
            location: [LOCATION_1, LOCATION_2.REGISTRATION],
        });
    }

    static logItemTypeVariable(itemType) {
        BaseEvent.data({
            itemType,
        });
    }

    static userData({ id, first_name, last_name, email, phone }) {
        BaseEvent.data({
            userFullName: `${first_name} ${last_name}`,
            userEmail: email,
            userPhone: phone,
            emailSha1Encryption: sha1 && sha1(email),
            userId: id,
        });
    }

    static userLoggedIn(leadId) {
        this._pushDataLayer({
            WorthyClientID: leadId,
        });
    }

    static funnelStage(value = 0, userData = {}) {
        BaseEvent.data({
            projectedLeadValue: value,
            itemsCount: userData.items_count,
            daysSinceUserCreated: userData.days_since_user_created,
        });
    }

    static registerFormSuccessfully() {
        BaseEvent.success({
            location: [LOCATION_1, LOCATION_2.REGISTRATION],
        });
    }

    static registerWithGoogleSuccessfully() {
        BaseEvent.success({
            location: [LOCATION_1, LOCATION_2.REGISTRATION, "google"],
        });
    }

    static loginFormPresented() {
        BaseEvent.open({
            location: [LOCATION_1, LOCATION_2.LOGIN],
        });
    }

    static loginFormSuccessfully() {
        BaseEvent.success({
            location: [LOCATION_1, LOCATION_2.LOGIN],
        });
    }

    static promotionBannerEventCallback() {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.LIGHT_LISTING, "promoBannerCta"],
        });
    }

    static promotionBannerClosedEvent() {
        BaseEvent.navigate({
            location: [
                LOCATION_1,
                LOCATION_2.LIGHT_LISTING,
                "promoBannerCloseBtn",
            ],
        });
    }

    static loginWithGoogleSuccessfully() {
        BaseEvent.success({
            location: [LOCATION_1, LOCATION_2.LOGIN, "google"],
        });
    }

    static hqPurchase(score, itemEstimation, userId) {
        // HQ purchase threshold is defined in GTM in the hqPurchase trigger
        BaseEvent.data({
            postregScore: score,
            estimationValue: itemEstimation,
            userId,
        });
    }

    static ml4PurchaseEvent(value) {
        BaseEvent.data({
            conversionValue: value,
        });
    }

    static lightListingPhotoUploadedSuccessfully() {
        BaseEvent.success({
            location: [LOCATION_1, LOCATION_2.LIGHT_LISTING],
            actionedObject: "photoUploaded",
        });
    }

    static lightListingPhotoUploadedClicked() {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.LIGHT_LISTING],
            actionedObject: "uploadImageBtn",
        });
    }

    static postRegistrationSurveyOpen() {
        BaseEvent.open({
            location: [LOCATION_1, LOCATION_2.POST_REG_SURVEY],
        });
    }

    static postRegistrationSurveyNext({ question, answer }) {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.POST_REG_SURVEY],
            actionedObject: question,
            actionedValue: answer || "noAnswer",
        });
    }

    static lightListingToplineInfoBanner({ text, status }) {
        BaseEvent.navigate({
            location: [
                LOCATION_1,
                LOCATION_2.LIGHT_LISTING,
                "toplineInfoBanner",
            ],
            actionedObject: text,
            actionedValue: status,
        });
    }

    static missingInfoPopupOpen() {
        BaseEvent.open({
            location: [
                LOCATION_1,
                LOCATION_2.LIGHT_LISTING,
                "missingInfoPopup",
            ],
        });
    }

    static missingInfoPopupSave() {
        BaseEvent.navigate({
            location: [
                LOCATION_1,
                LOCATION_2.LIGHT_LISTING,
                "missingInfoPopup",
            ],
            actionedObject: "saveMissingInfo",
        });
    }

    static lightListingScheduleCtasClicked() {
        const { valueCategory } = BaseEvent.dataObject;

        if (!valueCategory) {
            console.error(
                "valueCategory is misssing for lightListingScheduleCtasClicked event"
            );
        }

        const eventData = ({ buttonText, actionedObject3, actionedValue3 }) =>
            BaseEvent.navigate({
                location: [LOCATION_1, LOCATION_2.LIGHT_LISTING],
                actionedObject: "schedulingCtas",
                actionedValue: buttonText,
                actionedObject2: "valueCategory",
                actionedValue2: valueCategory,
                actionedObject3,
                actionedValue3,
            });

        return {
            scheduleCall: () => eventData({ buttonText: "scheduleCall" }),
            schedulePickup: () => eventData({ buttonText: "schedulePickup" }),
            scheduleInPersonAppointment: (eligibleOfficeTitle) =>
                eventData({
                    buttonText: "scheduleInPersonApt",
                    actionedObject3: "officeEligibility",
                    actionedValue3: _.camelCase(eligibleOfficeTitle),
                }),
        };
    }

    static lightListingScheduleCtasSuccess() {
        const { valueCategory } = BaseEvent.dataObject;

        if (!valueCategory) {
            console.error(
                "valueCategory is misssing for lightListingScheduleCtasSuccess event"
            );
        }
        const eventData = ({
            buttonText,
            actionedObject3,
            actionedValue3,
            actionedObject4,
            actionedValue4,
        }) =>
            BaseEvent.success({
                location: [LOCATION_1, LOCATION_2.LIGHT_LISTING],
                actionedObject: "schedulingCtas",
                actionedValue: buttonText,
                actionedObject2: "valueCategory",
                actionedValue2: valueCategory,
                actionedObject3,
                actionedValue3,
                actionedObject4,
                actionedValue4,
            });

        return {
            scheduleCall: () => eventData({ buttonText: "scheduleCall" }),
            schedulePickup: () => eventData({ buttonText: "schedulePickup" }),
            scheduleInPersonAppointment: (
                eligibleOfficeTitle,
                scheduledOfficeTitle
            ) =>
                eventData({
                    buttonText: "scheduleInPersonApt",
                    actionedObject3: "officeEligibility",
                    actionedValue3: _.camelCase(eligibleOfficeTitle),
                    actionedObject4: "officeScheduled",
                    actionedValue4: _.camelCase(scheduledOfficeTitle),
                }),
        };
    }

    static lightListingOpen(valueCategory, enabled, eligibleOfficeTitle) {
        if (valueCategory) {
            GA.setItemDetails({ valueCategory });
        }
        valueCategory = BaseEvent.dataObject.valueCategory;

        if (!valueCategory) {
            console.error(
                "valueCategory is misssing for lightListingOpen event"
            );
        }
        BaseEvent.open({
            location: [LOCATION_1, LOCATION_2.LIGHT_LISTING],
            actionedObject: "valueCategory",
            actionedValue: valueCategory,
            actionedObject2: "inPersonAptBtnActive",
            actionedValue2: enabled ? "true" : "false",
            actionedObject3: "officeEligibility",
            actionedValue3: _.camelCase(eligibleOfficeTitle),
        });
    }

    static lightListingSetUpShipmentPopupAddressProvided() {
        BaseEvent.navigate({
            location: [
                LOCATION_1,
                LOCATION_2.LIGHT_LISTING,
                "setUpShipmentPopup",
            ],
            actionedObject: "addressAdded",
        });
    }
    static lightListingSetUpShipmentPopupDeliveryScheduled({ shipmentType }) {
        BaseEvent.navigate({
            location: [
                LOCATION_1,
                LOCATION_2.LIGHT_LISTING,
                "setUpShipmentPopup",
            ],
            actionedObject: "deliveryScheduled",
            actionedValue: shipmentType,
        });
    }

    static lightListingLearnMore({ title }) {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.LIGHT_LISTING, "learnMorePopups"],
            actionedObject: title,
        });
    }

    static expertsConsultExpert() {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.HEADER],
            actionedObject: "consultExpert",
        });
    }
    static expertsStartSelling() {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.HEADER],
            actionedObject: "startSelling",
        });
    }

    static expertsHeaderLinks(actionedObject) {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.HEADER],
            actionedObject: actionedObject,
        });
    }

    static expertsResourcesAndTools() {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.HEADER],
            actionedObject: "resourcesAndTools",
        });
    }

    static expertsCalculatorSuccess() {
        BaseEvent.success({
            location: [LOCATION_1, LOCATION_2.LEARN, "calculator"],
        });
    }

    static updateReserveSimilarItems() {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.LIVE_AUCTION, "updateReserve"],
            actionedObject: "similarItems",
        });
    }

    static updateReserveFees() {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.LIVE_AUCTION, "updateReserve"],
            actionedObject: "fees",
        });
    }

    static updateReserveSelect(values) {
        const { current, old, recommended, fieldName, fieldValue } = values;

        BaseEvent.select({
            location: [LOCATION_1, LOCATION_2.LIVE_AUCTION, "updateReserve"],
            actionedObject: "newValue",
            actionedValue: current,
            actionedObject2: "previousValue",
            actionedValue2: old,
            actionedObject3: "recommendedValue",
            actionedValue3: recommended,
            fieldName,
            fieldValue,
        });
    }

    static updateReserveInput(values) {
        const { current, old, recommended, fieldName, fieldValue } = values;

        BaseEvent.input({
            location: [LOCATION_1, LOCATION_2.LIVE_AUCTION, "updateReserve"],
            actionedObject: "newValue",
            actionedValue: current,
            actionedObject2: "previousValue",
            actionedValue2: old,
            actionedObject3: "recommendedValue",
            actionedValue3: recommended,
            fieldName,
            fieldValue,
        });
    }

    static updateReserveSubmit({ fieldName, fieldValue }) {
        BaseEvent.submit({
            location: [LOCATION_1, LOCATION_2.LIVE_AUCTION, "updateReserve"],
            fieldName,
            fieldValue,
        });
    }

    static LoginFormEvents = {
        emailOTPClicked() {
            BaseEvent.navigate({
                location: [LOCATION_1, LOCATION_2.LOGIN, "otp"],
                actionedObject: "sendToEmail",
            });
        },
        phoneOTPClicked() {
            BaseEvent.navigate({
                location: [LOCATION_1, LOCATION_2.LOGIN, "otp"],
                actionedObject: "sendToPhone",
            });
        },
        resendCodeClicked() {
            BaseEvent.navigate({
                location: [LOCATION_1, LOCATION_2.LOGIN, "otp"],
                actionedObject: "resendCode",
            });
        },
        loginClicked() {
            BaseEvent.navigate({
                location: [LOCATION_1, LOCATION_2.LOGIN, "otp"],
                actionedObject: "login",
            });
        },
    };

    static headerLinkClicked(linkName) {
        BaseEvent.navigate({
            location: [LOCATION_1, LOCATION_2.HEADER],
            actionedObject: linkName,
        });
    }

    static giaCertificateModal = {
        navigate(actionedObject) {
            BaseEvent.navigate({
                location: [LOCATION_1, LOCATION_2.LIGHT_LISTING],
                actionedObject,
            });
        },
        submitted(actionedObject) {
            BaseEvent.submit({
                location: [
                    LOCATION_1,
                    LOCATION_2.LIGHT_LISTING,
                    "certificateModal",
                ],
                actionedObject,
            });
        },
    };
}
